import React, {useMemo} from 'react';
import {EmployeeTable} from './EmployeeTable';
import {Page, StorePageCount} from "../../components/page/Page";
import {LoadingData} from "../../components/loading-data/LoadingData";
import {employeeFilterSerializer, EmployeeTableFilter, filterEmployeeTableRows} from './EmployeeTableFilter';
import HiBobSyncButton from "./HiBobSyncButton";
import {useFilter} from "../../util/FilterSerializer";
import {useEmployeeHierarchyStore} from "../../api/EmployeeHierarchyStore";
import {useEmployeeNeighbourhoodStore} from "../../api/EmployeeNeighbourhoodStore";
import {Neighbourhood} from "../../api/Model";
import {ResidenceModel} from "../../api/ResidenceStore";
import {usePermission} from "../../util/access/UseAccess";
import {Employees_Admin} from "../../util/access/Permission";

export default function EmployeesPage({residenceModel, neighbourhoods}: {
    residenceModel: ResidenceModel,
    neighbourhoods: Neighbourhood[],
}) {
    const {canAdmin} = usePermission({canAdmin: Employees_Admin})
    const employeeNeighbourhoods = useEmployeeNeighbourhoodStore(state => state.remoteValue);
    const unfiltered = useEmployeeHierarchyStore(employeeNeighbourhoods);
    const filterSerializer = useMemo(
        () => employeeFilterSerializer(residenceModel, neighbourhoods),
        [residenceModel, neighbourhoods],
    );
    const [filter, setFilter] = useFilter(filterSerializer);

    const filtered = useMemo(
        () =>
            unfiltered.map(({employees: allEmployees}) => {
                    return filterEmployeeTableRows(allEmployees, filter);
                }
            ),
        [filter, unfiltered]
    );

    return (
        <Page
            header="Employees"
            counter={<StorePageCount totalValue={unfiltered} value={filtered}/>}
            actions={canAdmin ? <HiBobSyncButton/> : undefined}
            filter={
                <EmployeeTableFilter
                    filter={filter}
                    setFilter={setFilter}
                />
            }
        >
            <LoadingData
                totalValue={unfiltered}
                value={filtered}
                emptyMessage="No employees found."
                noMatchMessage="No employees match the current filters. Try adjusting your filter criteria."
                defaultErrorMessage="Failed to load employees data. Please try again later."
            >{rows =>
                <EmployeeTable rows={rows}/>
            }</LoadingData>
        </Page>
    );
}
